import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="content-spinner"
export default class extends Controller {
  static targets = ["spinner", "content", "media"]

  initialize() {
    this.hideSpinner = this.hideSpinner.bind(this)
    this.loadMedia = this.loadMedia.bind(this)
    this.handleMediaError = this.handleMediaError.bind(this)
  }

  connect() {
    if (!this.hasMediaTarget)
      return

    this.observer = new IntersectionObserver(this.loadMedia, {
      root: null,
      rootMargin: "0px 0px 300px 0px",
      threshold: 0.1
    })

    this.observer.observe(this.mediaTarget)
  }

  loadMedia(entries, observer) {
    entries.forEach(({ isIntersecting, target }) => {
      if (!isIntersecting)
        return

      switch (target.tagName) {
        case "VIDEO":
          this.handleVideo(target)
          break
        case "IMG":
          this.handleImage(target)
          break
      }

      observer.unobserve(target)
    })
  }

  handleImage(target) {
    this.showSpinner()
    target.src = target.dataset.src

    target.addEventListener("load", this.hideSpinner)
    target.addEventListener("error", this.handleMediaError)
  }

  handleMediaError(event) {
    this.hideSpinner()
    event.currentTarget.classList.add("hidden")
  }

  handleVideo(target) {
    this.showSpinner()
    target.preload = "metadata"
    target.load()

    const isReady = target.readyState >= 2

    isReady
      ? this.hideSpinner()
      : target.addEventListener("loadeddata", this.hideSpinner)
  }

  showSpinner() {
    this.spinnerTarget.classList.remove("hidden")
    this.contentTarget.classList.add("opacity-0")
  }

  hideSpinner() {
    this.spinnerTarget.classList.add("hidden")
    this.contentTarget.classList.remove("opacity-0")
  }
}
